import PatientDrawer, { isValidAgpPeriod } from './PatientDrawer';

export { isValidAgpPeriod };

export default PatientDrawer;